import {
  FETCH_BRANCH_LOOK_UPS_SUCCESS,
  FETCH_BRANCH_LOOK_UPS_REQUEST,
  FETCH_BRANCH_LOOK_UPS_FAILURE,
  UPDATE_BRANCH_LOOK_UP_REQUEST,
  UPDATE_BRANCH_LOOK_UP_SUCCESS,
  UPDATE_BRANCH_LOOK_UP_FAILURE,
  SHOW_BRANCH_LOOK_UP_EDIT_FORM,
  DELETE_BRANCH_LOOK_UP_REQUEST,
  DELETE_BRANCH_LOOK_UP_SUCCESS,
  DELETE_BRANCH_LOOK_UP_FAILURE,
  SET_BRANCH_LOOK_UP_VALIDATION_ERRORS,
  SHOW_BRANCH_LOOK_UP_NEW_FORM,
  CREATE_BRANCH_LOOK_UP_REQUEST,
  CREATE_BRANCH_LOOK_UP_SUCCESS,
  CREATE_BRANCH_LOOK_UP_FAILURE,
} from "constants/BranchLookUp";

import {
  addBranchLookup,
  formtValidationErrors,
  removeBranchLookup,
  updateBranchLookup,
} from "utils/BranchLookUp";

const initState = {
  loading: false,
  updating: false,
  creating: false,
  list: [],
  errorMessage: "",
  validationErrors: [],
  showEditForm: false,
  showNewForm: false,
  deleting: false,
};

const branchLookUp = (state = initState, action) => {
  switch (action.type) {
    case FETCH_BRANCH_LOOK_UPS_REQUEST:
      return {
        ...state,
        loading: true,
        showEditForm: false,
        showNewForm: false,
      };
    case FETCH_BRANCH_LOOK_UPS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case FETCH_BRANCH_LOOK_UPS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    case SET_BRANCH_LOOK_UP_VALIDATION_ERRORS:
      return {
        ...state,
        validationErrors: formtValidationErrors(action.payload),
      };
    case SHOW_BRANCH_LOOK_UP_EDIT_FORM:
      return {
        ...state,
        showEditForm: !state.showEditForm,
      };
    case SHOW_BRANCH_LOOK_UP_NEW_FORM:
      return {
        ...state,
        showNewForm: !state.showNewForm,
      };
    case UPDATE_BRANCH_LOOK_UP_REQUEST:
      return {
        ...state,
        updating: true,
        errorMessage: "",
        validationErrors: [],
      };
    case UPDATE_BRANCH_LOOK_UP_SUCCESS:
      return {
        ...state,
        updating: false,
        list: updateBranchLookup(state, action),
        errorMessage: "",
        validationErrors: [],
        showEditForm: false,
      };
    case UPDATE_BRANCH_LOOK_UP_FAILURE:
      return {
        ...state,
        updating: false,
        errorMessage: action.payload,
        validationErrors: [],
      };
    case DELETE_BRANCH_LOOK_UP_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case DELETE_BRANCH_LOOK_UP_SUCCESS:
      return {
        ...state,
        deleting: false,
        list: removeBranchLookup(state, action),
      };
    case DELETE_BRANCH_LOOK_UP_FAILURE:
      return {
        ...state,
        deleting: false,
        errorMessage: action.payload,
      };

    case CREATE_BRANCH_LOOK_UP_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case CREATE_BRANCH_LOOK_UP_SUCCESS:
      return {
        ...state,
        creating: false,
        showNewForm: !state.showNewForm,
        list: addBranchLookup(state, action),
      };
    case CREATE_BRANCH_LOOK_UP_FAILURE:
      return {
        ...state,
        creating: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default branchLookUp;
